import React from "react";
import Slider from "antd/lib/slider"
import 'antd/lib/slider/style/index.css';

import './patient-tv-report.scss';

function RiiSlider({ rii, id }) {
    if (isNaN(rii)) {
        rii = 0;
    }
    const value = (rii / 50) * 100;
    const marks = {
        10: {
            label: <strong style={{ fontSize: "28px" }}>{"5"}</strong>
        },
        30: {
            label: <strong style={{ fontSize: "28px" }}>{"5-15"}</strong>
        },
        70: {
            label: <strong style={{ fontSize: "28px" }}>{"15-30"}</strong>
        },
        // 85: {
        //     label: <strong style={{ fontSize: "28px" }}>{">30"}</strong>
        // }
    };

    return (
        <>
            <style>{`\
                #rii-slider-${id} .ant-slider-handle:after{\
                    content: '${Math.round(rii * 10) / 10}' !important;\
                }\
            `}</style>
            <div className="rii-slider" id={"rii-slider-" + id} >
                <Slider
                    marks={marks}
                    min={0}
                    style={{ fontSize: "28px" }}
                    max={100}
                    disabled
                    value={value}
                // tooltipPrefixCls="rii-slider-tooltip"
                />
            </div>
        </>
    )
}

export default RiiSlider;
